import { api } from "@/lib/api";
import { readConsent } from "@/lib/consent";

const KEY = "ozy_email";

/** Email connu de la visiteuse (popup de bienvenue ou commande), conservé dans son navigateur. */
export function rememberEmail(email) {
  try { if (email && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.trim())) localStorage.setItem(KEY, email.trim().toLowerCase()); } catch { /* stockage indisponible */ }
}

export function knownEmail() {
  try { return localStorage.getItem(KEY) || ""; } catch { return ""; }
}

/** Consultation d'un produit, uniquement si l'email est connu et la mesure d'audience acceptée. */
export function trackProductView(slug) {
  const email = knownEmail();
  if (!email || !slug || !readConsent()?.analytics) return;
  api.post("/track/product-view", { email, slug }).catch(() => {});
}

export function saveBirthday(email, day, month, source) {
  if (!email || !day || !month) return Promise.resolve();
  return api.post("/birthday", { email: email.trim(), day: Number(day), month: Number(month), consent: true, source }).catch(() => {});
}
